export default __webpack_public_path__ + "assets/salomao-zoppi-component.fb68b3d7.svg";